var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imServer-wrapper"},[_c('main',{staticClass:"imServer-main"},[_c('im-record',{staticClass:"item im-record",on:{"selectedChat":function($event){return _vm.selectedChat()}}}),(_vm.storeSelectedChatEn!=null)?_c('im-chat',{ref:"im_chat",staticClass:"item im-chat"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }